/**
 * @fileoverview aside に表示される PR 用資料のレイアウトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'PrDocumentCardBanners',

  props: {
    items: {
      type: Array as PropType<SolutionContentItem[]>,
      default: () => [],
    },
  },
})
</script>

<template>
  <section
    v-if="items.length"
    class="section">
    <div class="o-list__prDocument">
      <ul class="o-list__prDocument--items">
        <li
          v-for="item in items"
          :key="item.id"
          class="o-list__prDocument--item">
          <a
            class="l-unit__prDocument"
            :href="item.to"
            target="_blank">
            <div class="l-unit__prDocument--header">
              <div class="o-heading__prDocument">
                <p class="o-heading__prDocument--item">
                  {{ item.title }}
                </p>
              <!-- /.o-heading__prDocument --></div>
            <!-- /.l-unit__prDocument header --></div>

            <div class="l-unit__prDocument--image">
              <img
                class="img"
                :src="item.thumbImageUrl"
                loading="lazy"
                alt="">
            <!-- /.l-unit__prDocument image --></div>

            <div class="l-unit__prDocument--footer is-name">
              <div class="o-label__solutionName">
                <p class="o-label__solutionName--item">
                  {{ item.solution?.title }}
                </p>
              <!-- /.o-label__solutionName --></div>
            <!-- /.l-unit__prDocument footer --></div>
          <!-- /.l-unit__prDocument --></a>
        </li>
      </ul>
    <!-- /.o-list__prDocument --></div>
  </section>
</template>

<style lang="sass" scoped>
// layout
.l-unit__prDocument
  $root: &
  $image-width: 285
  $image-height: 160
  display: flex
  flex-direction: column
  text-decoration: none
  padding: 1em
  background-color: rgba($bg-white, 1)
  +transition

  & &--header
    margin-bottom: 0.5em

  & &--image
    order: -1
    position: relative
    margin-bottom: 1em

    &::before
      content: ''
      display: block
      width: 100%
      padding-top: getRelativeValue($image-height, $image-width)
      box-shadow: $box-shadow

    // overlay layer
    &::after
      content: ''
      width: 100%
      height: 100%
      display: block
      position: absolute
      top: 0
      left: 0
      background-color: rgba($bg-white, 0)
      +transition

    > .img
      width: 100%
      height: 100%
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      object-fit: cover

  +mouseover
    box-shadow: $box-shadow

    #{$root}--image
      &::after
        background-color: rgba($bg-white, 0.4)

    // 依存性管理
    .o-heading__prDocument--item
      text-decoration: underline

// object
.o-heading__prDocument
  & &--item
    color: $font-black
    font:
      size: $font-small
      weight: bold

.o-list__prDocument
  & &--item
    margin-top: 40px

    &:first-child
      margin-top: 0

.o-label__solutionName
  & &--item
    color: $font-light-gray
    font-size: $font-x-small
</style>
